<template>
  <div id="home">
    <!-- 头部登录部分 -->
    <div class="app-content">
      <div class="head-Login">
        <img src="../assets/lunbo4.jpg"
             alt=""
             style="width: 100%; height: 162px" />
        <ul class="head-menu">
          <li style="text-align: center"
              @click="toJinqifahui">
            <img src="../assets/jinqifahui.png"
                 alt=""
                 style="width: 48px; height: 48px" />
            <p style="margin-top: 2px">近期法会</p>
          </li>
          <li style="text-align: center"
              @click="toDonation">
            <img src="../assets/jingshengongde.png"
                 alt=""
                 style="width: 48px; height: 48px" />
            <p style="margin-top: 2px">敬神功德</p>
          </li>
          <li style="text-align: center"
              @onclick="toQiFuDeng">
            <a href="https://position.lmding.cn/SJLight/html/app/index.html#/user/introduce?locationName=54">
              <img src="../assets/qifudeng.png"
                   alt=""
                   style="width: 48px; height: 48px" />
              <p style="margin-top: 2px">祈福灯</p>
            </a>
          </li>
          <li style="text-align: center"
              @click="refData">
            <img src="../assets/huodongbaoming.png"
                 alt=""
                 style="width: 48px; height: 48px" />
            <p style="margin-top: 2px">活动报名</p>
          </li>
        </ul>
        <div style="
            margin-left: 16px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            margin-top: 16px;
            display: flex;
            justify-content: flex-start;
          ">
          道观简介
        </div>
        <div class="img-introduce">
          <!-- 使用Vant的轮播图组件 -->
          <div class="sub_Bigimg">
            <swiper :options="swiperOptions1"
                    ref="mySwiper1">
              <swiper-slide v-for="(image, index) in bigImages"
                            :key="index">
                <img :src="image"
                     alt="轮播图图片">
              </swiper-slide>
            </swiper>
          </div>
          <div class="sub-contanter-leftimgs">
            <swiper :options="swiperOptions2"
                    ref="mySwiper2">
              <swiper-slide v-for="(image, index) in bigImages"
                            :key="index">
                <img :src="image"
                     alt="轮播图图片">
              </swiper-slide>
            </swiper>
            <!-- <van-swipe :autoplay="3000"
                       indicator-color="white"
                       style="height: 196px;"
                       vertical
                       :show-indicators="false">
              <van-swipe-item v-for="(image, index) in bigImages"
                              :key="index">
                <img :src="image"
                     alt="">
                <div class="activied-frame"></div>
              </van-swipe-item>
            </van-swipe> -->
          </div>
        </div>
        <div class="detail-info">
          <div class="introduction fold"
               title="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海三泾庙古观，始于明嘉靖元年(1522年)，由刑部主事石德朝捐俸修建，迄今已有五百多年的历史。
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;清乾隆三十七年，曹天维等助田7.5亩扩建；光绪二十三年，里人复修慈航殿，光绪二十五年，重建群王殿，民国七年募修城隍殿。自清光绪年以后，该庙一直由务农张姓俗家道士住持。民国9年，三泾庙分为东、西两庙，东庙住持诸关麟，西庙住持张慎斋，人称东西三泾庙。
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;抗战期间，三泾庙毁于日军炮火。抗战胜利后，顾嘉堂等人发起募捐重建东西两庙，再塑神像。1950年，三泾庙改建为泾德小学，1983年并入长宁路第二小学 。
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2002年上海三泾庙收回部分产权。后在政府的关心支持与广大信众的愿望下，三泾庙于2009年始重新修缮对外开放，建有三官殿、三清殿、慈航殿、财神殿、药王殿、城隍殿、文昌殿等，为上海市区少有的正一派道教宫观之一。
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地址：位于长宁区长宁路1135弄三泾北宅244号
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮编：200050
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：021-62412538">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海三泾庙古观，始于明嘉靖元年(1522年)，由刑部主事石德朝捐俸修建，迄今已有五百多年的历史。
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;清乾隆三十七年，曹天维等助田7.5亩扩建；光绪二十三年，里人复修慈航殿，光绪二十五年，重建群王殿，民国七年募修城隍殿。自清光绪年以后，该庙一直由务农张姓俗家道士住持。民国9年，三泾庙分为东、西两庙，东庙住持诸关麟，西庙住持张慎斋，人称东西三泾庙。

            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;抗战期间，三泾庙毁于日军炮火。抗战胜利后，顾嘉堂等人发起募捐重建东西两庙，再塑神像。1950年，三泾庙改建为泾德小学，1983年并入长宁路第二小学
            。
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2002年上海三泾庙收回部分产权。后在政府的关心支持与广大信众的愿望下，三泾庙于2009年始重新修缮对外开放，建有三官殿、三清殿、慈航殿、财神殿、药王殿、城隍殿、文昌殿等，为上海市区少有的正一派道教宫观之一。
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地址：位于长宁区长宁路1135弄三泾北宅244号
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮编：200050
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：021-62412538
          </div>
          <!-- <div class="show-text" @click="toggleIntroduction">
            <div class="show-full">
              <img src="arrowIconUrl" class="arrow-image">
              <div class="show-text">展开</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="head-unLogin"></div>
    </div>
    <!-- 底部标签栏 -->
    <div id="tab-bar">
      <div class="tab-bar-item">
        <div>
          <img src="../assets/shouye.png"
               alt="" />
        </div>
        <div style="color: rgb(0, 0, 0)">
          <div>首页</div>
        </div>
      </div>
      <div class="tab-bar-item">
        <div>
          <img src="../assets/wode.png"
               alt="" />
        </div>
        <div>
          <div>我的</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      // 图片路径，这里需要替换为实际的路径
      bigImages: [
        require("@/assets/lunbo1.jpg"),
        require("@/assets/lunbo2.jpg"),
        require("@/assets/lunbo3.jpg"),
        require("@/assets/lunbo4.jpg"),
         require("@/assets/lunbo5.jpg"),
        require("@/assets/lunbo6.jpg"),
        require("@/assets/lunbo7.jpg"),
        require("@/assets/lunbo8.jpg"),
        require("@/assets/lunbo9.jpg"),
      ],
      smallImages: [
        require("@/assets/lunbo1.jpg"),
        require("@/assets/lunbo2.jpg"),
        require("@/assets/lunbo3.jpg"),
        require("@/assets/lunbo4.jpg"),
         require("@/assets/lunbo5.jpg"),
        require("@/assets/lunbo6.jpg"),
        require("@/assets/lunbo7.jpg"),
        require("@/assets/lunbo8.jpg"),
         require("@/assets/lunbo9.jpg"),
      ],
      swiperOptions1: {
        notNextTick: true,
        loop: true,
        autoplay: {
          // 隔×秒自动滑动一次
          delay: 3000,
          stopOnLastSlide: false,
          // 设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay。默认为true
          disableOnInteraction: false,
        },
        controller: {
          control: this.swiperOptions2
        },
      },
      swiperOptions2: {
        controller: {
          control: this.swiperOptions1
        },
        notNextTick: true,
        slidesPerView: 3,
        loop: true,
        direction: "vertical",
        autoplay: {
          // 隔×秒自动滑动一次
          delay: 3000,
          stopOnLastSlide: false,
          // 设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay。默认为true
          disableOnInteraction: false,
        },
        centeredSlides: true,
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    refData() {
      console.log(this.$refs)
      console.log(this.swiperobj1)
      this.$router.push("/jinqihuodong");
      localStorage.setItem("orderType", 2);
    },
    toJinqifahui() {
      this.$router.push("/JinQifahui");
      localStorage.setItem("orderType", 0);
    },
    toJinQiHuoDong() {
      this.$router.push("/jinqihuodong");
      localStorage.setItem("orderType", 2);
    },
    toDonation() {
      this.$router.push("/Donation");
      localStorage.setItem("orderType", 1);
    },
    toQiFuDeng() {
      window.location.href =
        "https://position.lmding.cn/SJLight/html/app/index.html#/user/introduce?locationName=54 ";
    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.app-content {
  font-family: Arial, sans-serif;
  width: 100%;
  height: 100%;
  padding-bottom: 75px;
}
.head-menu {
  padding-top: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  list-style: none;
  margin: 0 auto;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.head-menu p {
  font-size: 12px;
}
.date-area {
  background-color: #333;
  padding: 10px;
  margin-top: 10px;
}
.date-detail {
  color: white;
}
.date-yi-content img {
  vertical-align: middle;
  margin-right: 5px;
}
.img-introduce {
  margin: 8px 16px;
  height: 196px;
  position: relative;
}
.sub_Bigimg {
  position: absolute;
  width: 80%;
  height: 196px;
  left: 0;
  top: 0;
}
.sub_Bigimg img {
  width: 100%;
  height: 196px;
}
.swiper-thumbs .swiper-slide-active .activied-frame {
  width: 100%;
  height: 60px;
  border-radius: 4px;
  border: 1px solid #007aaa;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
}

.sub-contanter-leftimgs {
  top: 0;
  right: 0;
  bottom: 0;
  width: 17.5%;
  margin-left: 8px;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  overflow: hidden;
}
.sub-contanter-leftimgs img {
  width: 100%;
  height: 60px;
}
.sub-contanter-leftimgs .van-swipe-item {
  width: 100%;
  height: calc(100% / 3); /* 假设要一次显示3个幻灯片 */
  display: block;
}
.sub-contanter-leftimgs .van-swipe-item img {
  width: 100%;
  object-fit: cover;
}
.detail-info {
  margin-top: 10px;
}
.introduction.fold {
}
.introduction {
  width: calc(100vw - 32px);
  margin: 8px 16px 0;
  font-family: PingFangSC-Regular;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 25px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: 0;
}
.show-text {
  cursor: pointer;
  user-select: none;
  margin-top: 5px;
}
a {
  text-decoration: none;
  color: inherit;
  cursor: auto;
}
</style>
